/**
* 订单管理 交易订单
*/
<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>交易记录</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search"  @submit.native.prevent>
      <el-form-item label="搜索:">
         <el-select v-model="getJZ" placeholder="请选择" @change="handleNodeClick" size="small">
            <el-option
              v-for="item in treeDate"
              :key="item.id"
              :label="item.departmentName"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
			<el-form-item label="">
				<el-input size="small" @keyup.enter.native="search" v-model="formInline.meterPointName" placeholder="输入房间编号"></el-input>
			</el-form-item>
			<el-form-item >
				<el-input size="small" @keyup.enter.native="search" v-model="formInline.username" placeholder="输入用户账号"></el-input>
			</el-form-item>
      <el-form-item >
				<el-input size="small" @keyup.enter.native="search" v-model="formInline.meterPoint" placeholder="输入计量点地址"></el-input>
			</el-form-item>
			<el-form-item>
				<el-select size="small" v-model="formInline.isRecharge" placeholder="选择类型" style="width: 150px;" @change="search" >
					<el-option v-for="type in payType" :label="type.lable" :value="type.value" :key="type.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<div style="position: relative;top: 1px;">
				<el-date-picker
				  size="small"
				  v-model="dataStr"

				  type="daterange"
				  range-separator="至"
				  start-placeholder="开始日期"
				  @change="getDate"
				  end-placeholder="结束日期">
				</el-date-picker>
				</div>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<el-button size="small"  type="success" icon="el-icon-download" :loading="downloadLoadin" @click="exportdata">账单导出</el-button>
				<el-button size="small"  type="success" icon="el-icon-download" :loading="downloadJlLoadin" @click="exportJyData">交易记录导出</el-button>
			</el-form-item>
		</el-form>
		<!--列表-->



    <el-tabs type="border-card" @tab-click="changeData">
      <el-tab-pane label="交易记录">
        <el-table  :header-cell-style="this.$store.state.headerCss" size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
         style="width: 100%;"  stripe :max-height="tableHeight">
        	<el-table-column align="center" type="index" width="60">
        	</el-table-column>
        	<el-table-column prop="meterPointName" label="房间编号" sortable width="300"  show-overflow-tooltip>
        	</el-table-column>
        	<el-table-column prop="appletUserNames" label="用户账号" sortable width="260" show-overflow-tooltip>
        	</el-table-column>
        	<el-table-column prop="money" label="交易金额" sortable width="100" show-overflow-tooltip>
        	</el-table-column>
          <el-table-column prop="operationName" v-if="formInline.isRecharge != 2" label="交易人" sortable width="100" show-overflow-tooltip>
          </el-table-column>
        	<el-table-column  sortable prop="createDate" label="创建时间" width="180" show-overflow-tooltip>
        	</el-table-column>
        	<el-table-column prop="mark" label="备注"  show-overflow-tooltip>
        	</el-table-column>
        	<el-table-column  label="支付方式" width="120" sortable  show-overflow-tooltip v-if="!showJ">
        		<template slot-scope="scope">
              <div v-if="depId==101">
        			<span v-if="scope.row.payType == 7">多还少补</span>
        			<span v-if="scope.row.payType == 6">其他</span>
        			<span v-if="scope.row.payType == 5">微信</span>
        			<span v-if="scope.row.payType == 4">支付宝</span>
        			<span v-if="scope.row.payType == 3">POS</span>
        			<span v-if="scope.row.payType == 2">转账</span>
        			<span v-if="scope.row.payType == 1">现金</span>
            </div>
              <div v-else>
              <span v-if="scope.row.payType == 7">微信自助</span>
        			<span v-if="scope.row.payType == 6">其他调整</span>
        			<span v-if="scope.row.payType == 5">微信发票</span>
        			<span v-if="scope.row.payType == 4">支付宝发票</span>
        			<span v-if="scope.row.payType == 3">刷卡发票</span>
        			<span v-if="scope.row.payType == 2">转账发票</span>
        			<span v-if="scope.row.payType == 1">现金发票</span>
              </div>
        		</template>
        	</el-table-column>
        	<el-table-column prop="transType" label="交易类型" width="120" show-overflow-tooltip >
        		<template slot-scope="scope">
        			<span v-if="scope.row.isRecharge == 1">充值</span>
        			<span v-if="scope.row.isRecharge == 2">扣费</span>
        			<span v-if="scope.row.isRecharge == 3">退款</span>
              <span v-if="scope.row.isRecharge == 5">反算</span>
        		</template>
        	</el-table-column>
        	<el-table-column  label="起码" width="100" show-overflow-tooltip v-if="showJ">
        		<template slot-scope="scope">
        			<div>{{scope.row.lastDataValue}}</div>
        		</template>
        	</el-table-column>
        	<el-table-column  label="止码" width="100" show-overflow-tooltip v-if="showJ">
        		<template slot-scope="scope">
        			<div>{{scope.row.nowDataValue}}</div>
        		</template>

        	</el-table-column>
        <!-- 	<el-table-column  label="操作"  width="200" >
        		<template slot-scope="scope" >
              <el-button :disabled="formInline.isRecharge != 1" type="primary" @click="handelSJ(scope.row)" size="mini" >收据</el-button>
        		</template>
        	</el-table-column> -->
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-if="showPage" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="历史交易记录">
        <el-table  :header-cell-style="this.$store.state.headerCss" size="small" :data="hisListData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
         style="width: 100%;"  stripe :max-height="tableHeight">
        	<el-table-column align="center" type="index" width="60">
        	</el-table-column>
        	<el-table-column prop="meterPointName" label="房间编号" sortable width="300"  show-overflow-tooltip>
        	</el-table-column>
        	<el-table-column prop="appletUserNames" label="用户账号" sortable width="260" show-overflow-tooltip>
        	</el-table-column>
        	<el-table-column prop="money" label="交易金额" sortable width="100" show-overflow-tooltip>
        	</el-table-column>
          <el-table-column prop="operationName" v-if="formInline.isRecharge != 2" label="交易人" sortable width="100" show-overflow-tooltip>
          </el-table-column>
        	<el-table-column  sortable prop="createDate" label="创建时间" width="180" show-overflow-tooltip>
        	</el-table-column>
        	<el-table-column prop="mark" label="备注"  show-overflow-tooltip>
        	</el-table-column>
        	<el-table-column  label="支付方式" width="120" sortable  show-overflow-tooltip v-if="!showJ">
        		<template slot-scope="scope">
        			<!-- <span v-if="scope.row.payType == 7">多还少补</span>
        			<span v-if="scope.row.payType == 6">其他</span>
        			<span v-if="scope.row.payType == 5">微信</span>
        			<span v-if="scope.row.payType == 4">支付宝</span>
        			<span v-if="scope.row.payType == 3">POS</span>
        			<span v-if="scope.row.payType == 2">转账</span>
        			<span v-if="scope.row.payType == 1">现金</span> -->
              <div v-if="depId==101">
        			<span v-if="scope.row.payType == 7">多还少补</span>
        			<span v-if="scope.row.payType == 6">其他</span>
        			<span v-if="scope.row.payType == 5">微信</span>
        			<span v-if="scope.row.payType == 4">支付宝</span>
        			<span v-if="scope.row.payType == 3">POS</span>
        			<span v-if="scope.row.payType == 2">转账</span>
        			<span v-if="scope.row.payType == 1">现金</span>
            </div>
              <div v-else>
              <span v-if="scope.row.payType == 7">微信自助</span>
        			<span v-if="scope.row.payType == 6">其他调整</span>
        			<span v-if="scope.row.payType == 5">微信发票</span>
        			<span v-if="scope.row.payType == 4">支付宝发票</span>
        			<span v-if="scope.row.payType == 3">刷卡发票</span>
        			<span v-if="scope.row.payType == 2">转账发票</span>
        			<span v-if="scope.row.payType == 1">现金发票</span>
              </div>
        		</template>
        	</el-table-column>
        	<el-table-column prop="transType" label="交易类型" width="120" show-overflow-tooltip >
        		<template slot-scope="scope">
        			<span v-if="scope.row.isRecharge == 1">充值</span>
        			<span v-if="scope.row.isRecharge == 2">扣费</span>
        			<span v-if="scope.row.isRecharge == 3">退款</span>
              <span v-if="scope.row.isRecharge == 5">反算</span>
        		</template>
        	</el-table-column>
        	<el-table-column  label="起码" width="100" show-overflow-tooltip v-if="showJ">
        		<template slot-scope="scope">
        			<div>{{scope.row.lastDataValue}}</div>
        		</template>
        	</el-table-column>
        	<el-table-column  label="止码" width="100" show-overflow-tooltip v-if="showJ">
        		<template slot-scope="scope">
        			<div>{{scope.row.nowDataValue}}</div>
        		</template>

        	</el-table-column>
        <!-- 	<el-table-column  label="操作"  width="200" >
        		<template slot-scope="scope" >
              <el-button :disabled="formInline.isRecharge != 1" type="primary" @click="handelSJ(scope.row)" size="mini" >收据</el-button>
        		</template>
        	</el-table-column> -->
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-if="showPage" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


      </el-tab-pane>

    </el-tabs>








    <el-dialog title="回执" :visible.sync="editFormVisible" width="600px" @click="editFormVisible = false">
      <div class="h-container" ref="imageDom">
        <div class="h-header">
          <div class="h-title">转账交易成功</div>
          <p>此回单为客户自行打印，表示汇款申请已经提交资金到账状态以收款方账户为准</p>
        </div>
        <div class="h-main">
          <div class="h-item">
            <p class="item-t">转账金额</p>
            <p>{{huiZhi.money}}元</p>
          </div>
          <div class="h-item">
            <p class="item-t">交易时间</p>
            <p>{{huiZhi.createDate}}</p>
          </div>
          <div class="h-item">
            <p class="item-t">收款方</p>
            <p>{{huiZhi.payer}}</p>
          </div>
          <div class="h-item">
            <p class="item-t">付款人</p>
            <p>{{huiZhi.drawee}}</p>
          </div>
          <div class="h-item">
            <p class="item-t">付款方式</p>
            <p>{{ huiZhi.payType | payWay }}</p>
          </div>
          <div class="h-item">
            <p class="item-t">交易序号</p>
            <p>{{ huiZhi.orderNo}}</p>
          </div>
          <!-- <img  class="zhang"  :src="imgUrl+'?'+new Date().getTime()" crossorigin="anonymous"> -->

        </div>
        <div class="h-footer">
          <div><img src="../../assets/img/hcode.jpg" /></div>
          <p>关注 “广州昊美电力科技”发现更多精彩</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" :loading="setLoading" type="primary" @click="toImage" class="title">生成图片</el-button>
      	<el-button size="small" @click="editFormVisible = false">取消</el-button>
      </div>
    </el-dialog>




    <el-dialog title="收据" :visible.sync="shoujuVisbel" @click="shoujuVisbel = false" width="840px">
      <div class="sj-container" ref="print">
        <div class="sj-header">
          <h3>
            <p>收据</p>
            <span class="line"></span>
          </h3>
          <div class="sj-no">凭证号码：<span style="color: red; letter-spacing: 4px;">{{sjNo}}</span></div>
        </div>
        <div class="sj-content">
          <div class="sj-date">出据日期：{{sjDate.yyyy}} 年 {{sjDate.mm}} 月 {{sjDate.dd}} 日</div>
          <div style="padding: 20px;">
          <div class="input-item">
            <p class="i-lable">兹收到</p>
            <div class="i-value">
              {{sjeditForm.username}}
            </div>
          </div>
          <div class="input-item">
            <p class="i-lable">交来</p>
            <div class="i-value">
               {{sjeditForm.from}}
            </div>
          </div>
          <div class="input-item">
            <p class="i-lable">人民币</p>
            <div class="i-value">
              {{dxNum}}
              <span class="num">￥:{{sjeditForm.money}}元</span>
            </div>
          </div>
          </div>
          <div class="sj-silde">

            <span style="margin-bottom:10px;display: inline-block;">一存根</span>
            <span style="margin-bottom:10px;display: inline-block;">二客户</span>
            <span style="margin-bottom:10px;display: inline-block;">三财务</span>
          </div>
        </div>
        <div class="sj-footer">

          <div class="f-item">
           <div class="w200">
             <span class="kuan"></span>
             <span>填票</span>
           </div>
           <div class="w200">
             <span class="kuan"></span>
             <span>收款人</span>
           </div>
           <div style="width: 150px;">
             <span>会计</span>
           </div>
           <div>
             <span>收款单位</span>
           </div>
          </div>
        </div>


      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editSj" type="primary">编辑</el-button>
        <el-button size="small" @click="print" type="primary">打印</el-button>
      	<el-button size="small" @click="shoujuVisbel = false">取消</el-button>
      </div>
    </el-dialog>


    <!-- 长安顶峰收据 -->
    <el-dialog title="收据" :visible.sync="shoujuDfVisbel" @click="shoujuVisbel = false" width="890px" >
      <div class="sj-container df" ref="print" style="background: #fff8a3; ">
        <div class="sj-header df" style="margin-bottom: 8px;">
          <p style="margin: 4px;">东莞长安鼎峰商业管理有公司</p>
          <p style="">收&nbsp;&nbsp;据</p>

          <p style="font-size: 18px; ">{{sjDate.yyyy}} 年 {{sjDate.mm}} 月 {{sjDate.dd}} 日</p>
        </div>
        <div class="sj-content df" style="border: 0; position: relative; z-index: 1;" >

          <div >
          <div class="input-item">
            <p class="i-lable" style="width: 116px; text-align: right; margin-right: 6px; position: relative;top: 4px;">今收到</p>
            <div class="i-value" style="width: 350px;">
              {{sjeditForm.username}}
            </div>
          </div>
          <div class="input-item">
            <p class="i-lable" style=" width: 255px; position: relative;top: 4px;">人民币金额(大写)：</p>
            <div class="i-value">
              {{dxNum}}
            </div>
          </div>
          <div class="input-item">
            <p class="i-lable" style=" width: 40px; position: relative;top: 4px;">￥:</p>
            <div class="i-value" style="width:200px">
              {{sjeditForm.money}}元
            </div>
            <!-- <span class="num"></span> -->
          </div>
          <div class="input-item" style="position: relative;z-index: 10;">
            <p class="i-lable" style="width: 100px; text-align: right; margin-right: 6px;position: relative;top: 6px;" >系付</p>
            <div class="i-value">
               {{sjeditForm.from}}
            </div>
            <p style="font-size: 16px; position: absolute;right: 160px;top:33px; z-index: 11;">(收款单位盖章)</p>
          </div>


          </div>
         <!-- <div class="sj-silde">

            <span style="margin-bottom:10px;display: inline-block;">一存根</span>
            <span style="margin-bottom:10px;display: inline-block;">二客户</span>
            <span style="margin-bottom:10px;display: inline-block;">三财务</span>
          </div> -->
        </div>
        <div class="sj-footer" >

          <div class="f-item">
           <div class="w250">
             <span class="kuan"></span>
             <span>记账：</span>
           </div>
           <div class="w250">
             <span class="kuan"></span>
             <span>出纳：</span>
           </div>
           <div style="width: 150px;">
             <span>经手人：</span>
           </div>

          </div>
        </div>


      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button size="small" @click="editSj" type="primary">编辑</el-button> -->
        <el-button size="small" @click="print" type="primary">打印</el-button>
      	<el-button size="small" @click="shoujuDfVisbel = false">取消</el-button>
      </div>
    </el-dialog>



    <el-dialog title="编辑收据" :visible.sync="editSjVisbel" @click="editSjVisbel = false" width="30%">
      <el-form label-width="100px" :model="sjeditForm"  ref="editForm">
        <el-form-item label="出据日期">
          <el-date-picker
            @change="getSJdate"
            v-model="sjeditForm.date"
            value-format="yyyy-MM-dd"
            type="date"
            size="small"
            placeholder="选择日期">
          </el-date-picker>

        </el-form-item>
      	<el-form-item label="兹收到" v-if="!isDjj">
      		<el-input size="small" v-model="sjeditForm.username" auto-complete="off" ></el-input>
      	</el-form-item>
      	<el-form-item label="交来" v-if="!isDjj">
      		<el-input size="small" v-model="sjeditForm.from" auto-complete="off" ></el-input>
      	</el-form-item>
      	<el-form-item label="人民币"  size="small" v-if="!isDjj">
      		<el-input @change="fixNum(sjeditForm.money)" size="small" v-model="sjeditForm.money" auto-complete="off" ></el-input>
      	</el-form-item>

        <el-form-item label="复核" v-if="isDjj">
        	<el-input size="small" v-model="sjDjj.fh" placeholder="请输入复核" ></el-input>
        </el-form-item>
        <el-form-item label="会计" v-if="isDjj">
        	<el-input size="small" v-model="sjDjj.kj" placeholder="请输入会计" ></el-input>
        </el-form-item>
        <el-form-item label="出纳"  size="small" v-if="isDjj">
        	<el-input size="small" v-model="sjDjj.cn" placeholder="请输入出纳" ></el-input>
        </el-form-item>
        <el-form-item label="经手人"  size="small" v-if="isDjj">
        	<el-input  size="small" v-model="sjDjj.jsr" placeholder="请输入经手人" ></el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button size="small" type="primary" @click="saveSJ">保存</el-button> -->
      	<el-button size="small" @click="editSjVisbel = false">关闭</el-button>
      </div>
    </el-dialog>





  </div>
</template>

<script>
  import html2canvas from 'html2canvas';
	import { getAccountDetail,findAppletUserDepartment,findMeterBlanceAndEnergyType,getAccountHistory} from '../../api/payMG'
	import { poiAccountList,poiAccountDetailList,poiAccountHistoryList,findTradeReceiptByAccountId ,findVoucherByAccountId,getDepartmentTerminalInfoLis } from '../../api/energyMG.js'
	import {timestampToTime} from '@/utils/util'
	import Pagination from '../../components/Pagination'

  html2canvas(document.body).then(function(canvas) {
      document.body.appendChild(canvas);
  });
	export default {
		data() {
			return {
        shoujuDfVisbel:false,
				showPage:true,
        isDf:false,//长安鼎峰
        editSjVisbel:false,
				loading: false, //是显示加载
				editFormVisible: false, //控制编辑页面显示与隐藏
				payway:[],
				huiZhi:{
				  money:"",
				  createDate:"",
				  payer:"",
				  drawee:"",
				  payType:"",
				  orderNo:"",
				},
        isDjj:false,
        djj:{},
        sjDjj:{
          fh:"",
          kj:"",
          cn:"",
          jsr:"",
        },
        accountId:"",
        meterId:"",
        dtype:0,

        shoujuDjjVisbel:false,
        sjNo:"",
        dxNum:"",
        sjeditForm:{
          date:"",
          username:"",
          from:"",
          money:""
        },
        sjDate:{
          yyyy:'',
          mm:"",
          dd:""
        },
        djjForm:[],
				downloadLoadin:false,
				downloadJlLoadin : false,
				showJ:false,
        shoujuVisbel:false,
				payType:[
					{lable:'充值',value:1},
					{lable:'扣费',value:2},
					{lable:'退款',value:3},
          {lable:'反算',value:5}
				],
				setLoading:false,
				formInline: {
					currentPage: 1,
					pageSize: 10,
					username:'',
					meterPointName:'',
					isRecharge:1,
          meterPoint:"",
					// startTime:timestampToTime(new Date()).substring(0, 10),
					// endTime:timestampToTime(new Date()).substring(0, 10),
					startTime:'',
					endTime:'',
          deptId:'',
				},

        screenshotImage:"",
				imgUrl:"",
				listData: [],
        hisListData:[],
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 10,
					total: 10
				},
        tableHeight:0,
				exportParam:{
					startTime:timestampToTime(new Date()).substring(0, 10),
					endTime:timestampToTime(new Date()).substring(0, 10),

				},
				dataStr:[],
        user:{},
        getJZ:"",
        treeDate:[],
        depId:'',
			}
		},
		// 注册组件
		components: {
			Pagination
		},
		/**
		 * 数据发生改变
		 */

    mounted(){
      this.$nextTick(() => {

        this.tableHeight = window.innerHeight - 300
      })
    },
		created() {
      this.getJzData();
			// this.getdata()
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      console.log(this.user.departmentId)
		},

		/**
		 * 里面的方法只有被调用才会执行
		 */

    filters:{
      payWay(val){
        if(val == 1){
          return '现金'
        }else if(val == 2){
          return '转账'
        }else if(val == 3){
          return 'POST'
        }else if(val == 4){
          return '支付宝'
        }else if(val == 5){
          return '微信'
        }else if(val == 6 || val == 0){
          return '其他'
        }else{
          return '多还少补'
        }
      }
    },
		methods: {
      //获取集中器信息
			getJzData:function(){
				return new Promise((resolve,reject) => {
					getDepartmentTerminalInfoLis().then(res => {
						// this.treeLoad = false
						if(res.status == 1){
							let arr = []
              this.treeDate = res.data.menuDepList
              this.formInline.deptId = this.treeDate[0].id
              this.depId = this.treeDate[0].id
              this.getJZ = this.treeDate[0].departmentName
              this.getdata()
							// this.getDepIds(JSON.parse(sessionStorage.getItem('userdata')).departmentId)
							resolve(res.data.terIds)
						}
						else{
							this.$message.error(res.msg)
						}
					})
				})

			},
      handleNodeClick(data) {
        this.formInline.deptId = data
        // this.getJZ = data.departmentName
        this.depId = data
        console.log('data--',data)
      },
      randomn(n) {
        if (n > 21) return null
        return parseInt((Math.random() + 1) * Math.pow(10,n-1))
      },


      saveSJ(){
      },

      editSj(){
        this.editSjVisbel = true
      },
      print(){
         this.$print(this.$refs.print)
      },

      getSJdate(){
        this.sjDate.yyyy = this.sjeditForm.date.substring(0,4)
        this.sjDate.mm  =  this.sjeditForm.date.substring(5,7)
        this.sjDate.dd  =  this.sjeditForm.date.substring(8,10)

      },

      handelSJ(row){

        this.sjNo = this.randomn(6)
        this.sjeditForm.username = row.appletUserNames
        this.sjeditForm.from = row.meterPointName + '充值'
        this.sjeditForm.money = row.money
        this.sjeditForm.date = timestampToTime(new Date()).substring(0, 10),
        this.sjDate.yyyy = this.sjeditForm.date.substring(0,4)
        this.sjDate.mm  =  this.sjeditForm.date.substring(5,7)
        this.sjDate.dd  =  this.sjeditForm.date.substring(8,10)
        this.djj.appletUserNames = row.appletUserNames
        this.djj.meterPointName = row.meterPointName
        this.dxNum = this.changeNum(row.money)
        let param = {
          accountId:row.id
        }
        if(this.user.departmentId == 57){
          this.shoujuDfVisbel = true
        }else{
          this.shoujuVisbel = true
        }
      },


      getDjjShouJu(){
        return new Promise((reslove,rejcet) => {
          let param = {
            meterId:this.meterId,
            accountId:this.accountId
          }
          findMeterBlanceAndEnergyType(param).then(res => {
            if(res.status == 1){
              this.djj.money = res.data.money
              this.djj.type =  res.data.type
              reslove()
            }
          })
        })

      },


      fixNum(n){
         this.dxNum = this.changeNum(n)
      },
      changeNum(n) {
          var fraction = ['角', '分'];
          var digit = [
              '零', '壹', '贰', '叁', '肆',
              '伍', '陆', '柒', '捌', '玖'
          ];
          var unit = [
              ['元', '万', '亿'],
              ['', '拾', '佰', '仟']
          ];
          var head = n < 0 ? '欠' : '';
          n = Math.abs(n);
          var s = '';
          for (var i = 0; i < fraction.length; i++) {
              s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
          }
          s = s || '整';
          n = Math.floor(n);
          for (var i = 0; i < unit[0].length && n > 0; i++) {
              var p = '';
              for (var j = 0; j < unit[1].length  && n > 0; j++) {
                  p = digit[n % 10] + unit[1][j] + p;
                  n = Math.floor(n / 10);
              }
              s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
          }
          return head + s.replace(/(零.)*零元/, '元')
              .replace(/(零.)+/g, '零')
              .replace(/^整$/, '零元整');
      },


      showHuiZhi(id){
        this.editFormVisible = true
        let params = {
          accountId:id,
          dealTtype:1
        }
        findTradeReceiptByAccountId(params).then(res => {
          if(res.status == 1){
            if(res.data.imgPath){
              let tempArr = JSON.parse(res.data.imgPath)
              this.imgUrl = tempArr[0].url
            }
            if( res.data.data[0]){
              this.huiZhi.money = res.data.data[0].money
              this.huiZhi.createDate = res.data.data[0].createDate
              this.huiZhi.payer = res.data.data[0].payer
              this.huiZhi.drawee = res.data.data[0].drawee
              this.huiZhi.payType = res.data.data[0].payType
              this.huiZhi.orderNo = res.data.data[0].orderNo

            }else{
              this.huiZhi.money = '--'
              this.huiZhi.createDate =  '--'
              this.huiZhi.payer =  '--'
              this.huiZhi.drawee =  '--'
              this.huiZhi.payType = 0
              this.huiZhi.orderNo =  '--'
            }

          }

        })
      },

      async toImage(){
         this.setLoading = true
         const opts = {

         }
         html2canvas(this.$refs.imageDom,{
                backgroundColor: '#ffffff',
                useCORS: true,

            }).then(canvas => {
                // this.screenshotImage = canvas.toDataURL('image/jpg')
                var imgData = canvas.toDataURL("image/jpeg");
                this.setLoading = false
                this.fileDownload(imgData);

            })

      },
      fileDownload(downloadUrl) {
          let aLink = document.createElement("a");
          aLink.style.display = "none";
          aLink.href = downloadUrl;
          aLink.download = "回执.png";
          // 触发点击-然后移除
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
      },

			exportdata(){
				this.downloadLoadin = true
				let param =  {
          ...this.exportParam,
          meterPointName:this.formInline.meterPointName,
          meterPoint:this.formInline.meterPoint
        }
				poiAccountList(param).then(res => {

					var blob = new Blob([res], {type: 'application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
					var downloadElement = document.createElement('a');
				　　var href = window.URL.createObjectURL(blob); //创建下载的链接
				　　downloadElement.href = href;
				　　downloadElement.download = 'result.xls'; //下载后文件名
				　　document.body.appendChild(downloadElement);
				　　downloadElement.click(); //点击下载
				　　document.body.removeChild(downloadElement); //下载完成移除元素
				　　window.URL.revokeObjectURL(href); //释放掉blob对象
					this.downloadLoadin = false
					this.$message.success('表格生成成功！正在下载')
				}).catch(err => {
					this.downloadLoadin = false
					this.$message({
						message:'下载失败！',
						type:'error',
						showClose:true
					})
				})

			},


      exportJyData(){
        if(this.dtype == 0){
          this.exportJldata()
        }else{
          this.exportHisdata()
        }
      },

			exportJldata(){
				this.downloadJlLoadin = true

				let param = {
					username:this.formInline.username,
					meterPointName: this.formInline.meterPointName,
					isRecharge: this.formInline.isRecharge,
					startTime: this.formInline.startTime,
					endTime:this.formInline.endTime,
          meterPoint:this.formInline.meterPoint
				}
				poiAccountDetailList(param).then(res => {
					var blob = new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
					var downloadElement = document.createElement('a');
				　　var href = window.URL.createObjectURL(blob); //创建下载的链接
				　　downloadElement.href = href;
				　　downloadElement.download = '交易记录.xls'; //下载后文件名
				　　document.body.appendChild(downloadElement);
				　　downloadElement.click(); //点击下载
				　　document.body.removeChild(downloadElement); //下载完成移除元素
				　　window.URL.revokeObjectURL(href); //释放掉blob对象
					this.downloadJlLoadin = false
					this.$message.success('表格生成成功！正在下载')
				}).catch(err => {
					this.downloadJlLoadin = false
					this.$message({
						message:'下载失败！',
						type:'error',
						showClose:true
					})
				})
			},

      exportHisdata(){
      	this.downloadJlLoadin = true

      	let param = {
      		username:this.formInline.username,
      		meterPointName: this.formInline.meterPointName,
      		isRecharge: this.formInline.isRecharge,
      		startTime: this.formInline.startTime,
      		endTime:this.formInline.endTime,
          meterPoint:this.formInline.meterPoint
      	}
      	poiAccountHistoryList(param).then(res => {
      		var blob = new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
      		var downloadElement = document.createElement('a');
      	　　var href = window.URL.createObjectURL(blob); //创建下载的链接
      	　　downloadElement.href = href;
      	　　downloadElement.download = '历史交易记录.xls'; //下载后文件名
      	　　document.body.appendChild(downloadElement);
      	　　downloadElement.click(); //点击下载
      	　　document.body.removeChild(downloadElement); //下载完成移除元素
      	　　window.URL.revokeObjectURL(href); //释放掉blob对象
      		this.downloadJlLoadin = false
      		this.$message.success('表格生成成功！正在下载')
      	}).catch(err => {
      		this.downloadJlLoadin = false
      		this.$message({
      			message:'下载失败！',
      			type:'error',
      			showClose:true
      		})
      	})
      },

      changeData(e){

        this.formInline.currentPage == 1
        this.dtype = e.index
        this.showPage = false
        if(e.index == 0){
          this.getdata()
        }else{
          this.getHisdata()
        }

        this.$nextTick(() => {
          this.showPage = true
        })
      },

      getdata() {
				this.loading = true
				getAccountDetail(this.formInline)
					.then(res => {
						this.loading = false
						if (res.status == 1) {
							this.listData = res.data.data
							// 分页赋值
							this.pageparm.currentPage = this.formInline.currentPage
							this.pageparm.pageSize = this.formInline.pageSize
							this.pageparm.total = res.data.totalCount
							this.$nextTick(() => {
								this.showJ = this.formInline.isRecharge === 2
							})

						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.loading = false
						this.$message.error('数据加载失败，请稍后再试！')
					})
			},

      //获取历史数据
      getHisdata() {
      	this.loading = true
      	getAccountHistory(this.formInline)
      		.then(res => {
      			this.loading = false
      			if (res.status == 1) {
      				this.hisListData = res.data.data
      				// 分页赋值
      				this.pageparm.currentPage = this.formInline.currentPage
      				this.pageparm.pageSize = this.formInline.pageSize
      				this.pageparm.total = res.data.totalCount
      				this.$nextTick(() => {
      					this.showJ = this.formInline.isRecharge === 2
      				})

      			} else {
      				this.$message({
      					type: 'info',
      					message: res.msg
      				})
      			}
      		})
      		.catch(err => {
      			this.loading = false
      			this.$message.error('数据加载失败，请稍后再试！')
      		})
      },

			  // 分页插件事件
			callFather(parm) {
			  this.formInline.currentPage = parm.currentPage
			  this.formInline.pageSize = parm.pageSize
        if(this.dtype == 0){
           this.getdata(this.formInline)
        }else{
          this.getHisdata()
        }
			},
			// 搜索事件
			search() {
			  this.pageparm.currentPage = 1
			  this.formInline.currentPage = 1
			  this.showPage  =  false;
        if(this.dtype == 0){
          this.getdata(this.formInline)
        }else{
          this.getHisdata()
        }

			  this.$nextTick(() => {
			  	this.showPage = true
			  })
			},

			tableRowClassName({row, rowIndex}) {
				if (rowIndex === 1) {
				  return 'warning-row';
				} else if (rowIndex === 3) {
				  return 'success-row';
				}
				return '';
			},
			getDate(val){
				this.exportParam.startTime  = timestampToTime(this.dataStr[0]).substring(0, 10)
				this.exportParam.endTime  = timestampToTime(this.dataStr[1]).substring(0, 10)
				this.formInline.startTime  = timestampToTime(this.dataStr[0]).substring(0, 10)
				this.formInline.endTime  = timestampToTime(this.dataStr[1]).substring(0, 10)

				this.search()

			}


		}
	}
</script>

<style scoped>

	.sj-container{
    width: 100%;
    height: 380px;
    background: url(../../assets/img/sbg.png);
    color: #000000;
    font-family: "楷体";
    overflow: hidden;
    padding: 10px 0 0 0;
  }
  .sj-container.df{
    background:none;
  }
  .sj-header{
    text-align: center;
    font-size: 30px;
    margin-bottom: 33px;
    position: relative;
  }
  .sj-header .sj-no{
    font-size: 20px;
    position: absolute;
    top: 40px;
    right: 42px;
  }
   .sj-header h3{
     margin: 0 auto;
     padding-top: 30px;
     width: 100px;
     border-bottom: 3px solid #000000;
     position: relative;

   }
   .sj-header h3 p{
     margin: 0;
   }

  .sj-header h3 .line{
     width: 100px;
     height: 2px;
     position: absolute;
     bottom: -6px;
     left: 0;
     border-bottom: 1px solid #000000;
   }

  .sj-content{
     position: relative;
     width: 710px;
     height: 190px;
     margin: 0 auto;
     border: 2px solid #000000;
  }
  .sj-container.df .sj-content{
    width: 774px;
  }

  .sj-silde{
    position: absolute;
    width: 20px;
    right: -30px;
    top: 10px;
   }
  .sj-date{
    position: absolute;
    font-size: 16px;
    right: 0;
    top: -26px;
  }
  .sj-content p{
    margin: 0;
  }
  .f-item{
    display: flex;
    font-size: 20px;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .f-item div{

  }
  .f-item .w200{
    width: 200px;
  }
  .f-item .w250{
    width: 250px;
  }
  .input-item{
    font-size: 20px;
    display: flex;
    line-height: 32px;
    margin-bottom: 20px;
   }

   .sj-content.df .input-item{
      margin-bottom: 15px;
   }
   .i-lable{
     width: 80px;
   }

   .i-value{
     border-bottom: 1px solid #000000;
     width: 100%;
     position: relative;
     padding-left: 4px;
     line-height: 30px;

   }
   .i-value .num{
     position: absolute;
     right: 0;
   }



  .sj-footer{
    width: 710px;
    margin: 10px auto;
    font-size: 14px;
    overflow: hidden;
  }



  .userRole {
		width: 100%;
	}
  .h-container{
    width: 560px;

    padding: 0;
    background: url(../../assets/img/hbg.png);
  }
  .h-header{
    padding: 20px 0;
    border-bottom: 1px solid #e4e4e4;
  }
  .h-header .h-title{
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    color: #000000;
  }
  .h-header p{
    padding: 0 20px;

    font-size: 18px;
    color: #999999;
    text-align: center;
    line-height: 30px;
    letter-spacing: 4px;

    margin: 10px auto;
  }

  .h-main{
    padding: 30px 40px;
    border-bottom: 1px solid #e4e4e4;
    position: relative;
  }
  .zhang{
    position: absolute;
    bottom: 20px;
    right: 20px;
    opacity: 0.8;
    width: 240px;
  }
  .h-item{
    display: flex;
    font-size: 16px;
  }
  .item-t{
    width: 252px;
    color: #333333;
  }
  .h-footer{
     padding: 30px 40px;
    display: flex;
  }
  .h-footer p{
    font-size: 20px;

    margin-left: 10px;
  }



.sj-header.df p{
  margin: 0;
}


</style>



// WEBPACK FOOTER //
// src/views/prepayment/pay.vue